import React, { useState } from "react";
import { message, Grid } from "antd";
import HeaderBar from "../components/common/CommonHeader";
import FooterBar from "../components/common/CommonFooter";
import ContactSection from "../components/Contact_Section";
import { firebaseService } from "../lib/services/firebaseService";
import { ContactMessage } from "../types/contactMessage";

const { useBreakpoint } = Grid;

const ContactUs = () => {
  const [loading, setLoading] = useState(false);
  const screens = useBreakpoint();

  const handleSubmitContact = async (formData) => {
    try {
      setLoading(true);

      // Create contact message
      const contactMessage = new ContactMessage({
        id: `contact-${Date.now()}`,
        fullName: formData.fullName,
        email: formData.email,
        phoneNumber: formData.phone,
        message: formData.message,
        companyName: formData.company || "",
      });

      // Save to Firebase
      await firebaseService.addContactMessage(contactMessage);

      message.success(
        "Your message has been sent successfully! We'll get back to you soon."
      );
    } catch (error) {
      console.error("Error sending message:", error);
      message.error("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <HeaderBar bgColor="#DDC7BB" />
      <div
        style={{
          backgroundColor: "#F7F7F7",
          minHeight: "100vh",
          padding: screens.xs ? "20px 0" : "40px 0",
        }}
      >
        <ContactSection
          onSubmit={handleSubmitContact}
          loading={loading}
          isMobile={!screens.md}
        />
      </div>
      <FooterBar />
    </>
  );
};

export default ContactUs;
